(function () {
  'use strict';
  var OD = 80, CD = 250, mq = window.matchMedia('(min-width: 1001px)'), cdT = 0;
  var W, scrim, trigs = [], cur = null, curP = null, tm = 0, lastPt = 'mouse';

  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function trigA(dd) { return dd.querySelector(':scope>a'); }
  function later(fn, d) { clearTimeout(tm); tm = setTimeout(fn, d); }
  function panelOf(dd) { return document.getElementById('mpx-' + dd.dataset.mpx); }
  function focusables() { return curP ? $$('a[href]', curP).filter(function (a) { return a.offsetParent !== null && a.tabIndex !== -1; }) : []; }

  /* countdown to the running sale's end (seconds since 1970 in data-end), ticks only while a panel is open */
  function p2(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = Date.now() / 1000;
    $$('.mpx-cd[data-end]', W).forEach(function (el) {
      var s = Math.floor(+el.dataset.end - now), b = el.querySelector('b');
      if (!(s > 0)) { el.hidden = true; return; }
      if (b) b.textContent = Math.floor(s / 86400) + 'D ' + p2(Math.floor(s % 86400 / 3600)) + ':' + p2(Math.floor(s % 3600 / 60)) + ':' + p2(s % 60);
    });
    /* layout g: the same time in unit boxes */
    $$('.mpx-cdx[data-end]', W).forEach(function (el) {
      var s = Math.floor(+el.dataset.end - now), u = el.querySelectorAll('.mpx-cdu b');
      if (!(s > 0)) { el.hidden = true; return; }
      var d = Math.floor(s / 86400), v = [d > 99 ? '' + d : p2(d), p2(Math.floor(s % 86400 / 3600)), p2(Math.floor(s % 3600 / 60)), p2(s % 60)];
      for (var i = 0; i < u.length && i < 4; i++) if (u[i].textContent !== v[i]) u[i].textContent = v[i];
    });
  }

  function place() {
    var h = document.querySelector('.hdr');
    var t = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 107;
    W.style.setProperty('--mpx-top', t + 'px');
    scrim.style.setProperty('--mpx-top', t + 'px');
    var lk = W.dataset.look;
    if (!curP || lk === 'c') return;
    /* b, m1: card centred under its item, the series index centred on the page. m2: one width, lined up with the menu's
       left edge. m3: wide two pane card centred on the page. Always kept 16 px inside the window. */
    var vw = document.documentElement.clientWidth, w = curP.offsetWidth, a = trigA(cur), x, nav = document.getElementById('nav');
    if (lk === 'm2' && nav) { var f = nav.firstElementChild, fa = f && (f.matches('a') ? f : f.querySelector(':scope>a')); x = (fa || nav).getBoundingClientRect().left; }
    else if (lk === 'm3' || lk === 'mf' || cur.dataset.mpx === 'anime' || !a) x = (vw - w) / 2;
    else { var r = a.getBoundingClientRect(); x = r.left + r.width / 2 - w / 2; }
    x = Math.max(16, Math.min(x, vw - w - 16));
    curP.style.setProperty('--mpx-x', Math.round(x) + 'px');
  }
  function mark(dd, on) {
    dd.classList.toggle('mpx-cur', on);
    var a = trigA(dd);
    if (a) a.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  function open(dd) {
    if (!mq.matches || !dd) return;
    var p = panelOf(dd);
    if (!p) return;
    clearTimeout(tm);
    if (cur === dd && !p.hidden) return;
    if (cur && cur !== dd) mark(cur, false);
    if (curP && curP !== p) { curP.hidden = true; rest(curP); }
    cur = dd; curP = p; mark(dd, true);
    if (p.hidden) p.hidden = false;
    scrim.hidden = false;
    document.body.classList.add('mpx-on');
    place();
    if (p._ends) p._ends();
    if (p.querySelector('.mpx-cd,.mpx-cdx')) { tick(); clearInterval(cdT); cdT = setInterval(tick, 1000); }
  }
  function close() {
    clearTimeout(tm);
    if (!curP) return;
    clearInterval(cdT);
    curP.hidden = true; scrim.hidden = true;
    document.body.classList.remove('mpx-on');
    if (cur) mark(cur, false);
    rest(curP);
    cur = null; curP = null;
  }

  /* preview: back to the printed first layer when a panel closes */
  function rest(p) {
    $$('.mpx-pv', p).forEach(function (pv) {
      if (pv._rest != null && pv.dataset.cur) pv.innerHTML = pv._rest;
      pv.dataset.cur = '';
    });
    $$('.mpx-split', p).forEach(function (sp) {
      var rows = $$('[data-t]', sp);
      rows.forEach(function (x) { x.classList.toggle('hv', !!x.dataset.hv0); });
    });
  }
  function show(el) {
    var sp = el.closest('.mpx-split'), pv = sp && sp.querySelector('.mpx-pv');
    if (!pv) return;
    var id = el.dataset.t + '|' + (el.getAttribute('href') || '');
    if (pv.dataset.cur === id) return;
    if (!pv.dataset.cur && el.classList.contains('hv') && pv.children.length === 1) { pv.dataset.cur = id; return; }
    pv.dataset.cur = id;
    $$('.hv', sp).forEach(function (x) { x.classList.remove('hv'); });
    el.classList.add('hv');
    var d = el.dataset, ps = (d.p || '').trim().split(/\s+/).filter(Boolean).slice(0, 4);
    var L = document.createElement('a');
    L.className = 'mpx-lay';
    L.href = el.getAttribute('href') || '#';
    L.tabIndex = -1;
    L.setAttribute('aria-hidden', 'true');
    L.innerHTML = '<span class="mpx-art">' + (d.art ? '<img alt="" decoding="async" width="800" height="1000" src="' + esc(d.art) + '"' + (d.arts ? ' srcset="' + esc(d.arts) + '" sizes="(min-width: 1300px) 420px, 340px"' : '') + '>' : '') + '</span>' +
      '<span class="mpx-cap"><span class="mpx-ck">' + esc(d.k) + (d.jp ? '<em lang="ja">' + esc(d.jp) + '</em>' : '') + '</span>' +
      '<span class="mpx-ct">' + esc(d.t) + '</span>' + (d.n ? '<span class="mpx-cs">' + esc(d.n) + '</span>' : '') +
      (ps.length ? '<span class="mpx-pp">' + ps.map(function (u) { return '<span><img alt="" decoding="async" src="' + esc(u) + '" width="64" height="64"></span>'; }).join('') + '</span>' : '') +
      '<span class="mpx-cb">' + esc(d.cta) + '</span></span>';
    pv.appendChild(L);
    var go = function () { if (L.isConnected) L.classList.add('in'); };
    var img = L.querySelector('.mpx-art img');
    void L.offsetWidth;
    if (img && !img.complete && img.decode) {
      var t = setTimeout(go, 160);
      img.decode().then(function () { clearTimeout(t); requestAnimationFrame(go); }, function () { clearTimeout(t); go(); });
    } else requestAnimationFrame(go);
    setTimeout(function () { while (L.isConnected && pv.firstChild && pv.firstChild !== L) pv.removeChild(pv.firstChild); }, 700);
  }

  function bind() {
    W = document.getElementById('mpx');
    if (!W || W._mpx) return;
    W._mpx = 1;
    trigs = $$('#nav .dd[data-mpx]').filter(function (dd) { return !!panelOf(dd); });
    if (!trigs.length) return;
    scrim = W.nextElementSibling && W.nextElementSibling.classList.contains('mpx-scrim') ? W.nextElementSibling : null;
    if (!scrim) { scrim = document.createElement('div'); scrim.className = 'mpx-scrim'; scrim.hidden = true; W.after(scrim); }
    scrim.addEventListener('click', close);
    $$('.mpx-split .hv', W).forEach(function (x) { x.dataset.hv0 = '1'; });
    $$('.mpx-pv', W).forEach(function (pv) { pv._rest = pv.innerHTML; });

    trigs.forEach(function (dd) {
      var a = trigA(dd);
      dd.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'mouse') return; later(function () { open(dd); }, curP ? 0 : OD); });
      dd.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'mouse') return; later(close, CD); });
      if (!a) return;
      a.addEventListener('pointerdown', function (e) { lastPt = e.pointerType; });
      /* touch or pen: first tap opens, a second tap follows the link. Mouse and keyboard: the link works as a link. */
      a.addEventListener('click', function (e) { if (lastPt !== 'mouse' && mq.matches && cur !== dd) { e.preventDefault(); open(dd); } lastPt = 'mouse'; });
      a.addEventListener('focus', function () { if (a._mpxQuiet) { a._mpxQuiet = 0; return; } if (a.matches(':focus-visible')) open(dd); });
      a.addEventListener('keydown', function (e) {
        if ((e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey)) && cur === dd && curP) {
          var f = focusables()[0];
          if (f) { e.preventDefault(); f.focus(); }
        } else if (e.key === 'ArrowDown') { e.preventDefault(); open(dd); var g = focusables()[0]; if (g) g.focus(); }
      });
    });
    /* other top items (Home): close at once */
    $$('#nav > a, #nav > .dd:not([data-mpx])').forEach(function (x) {
      x.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && cur) close(); });
      x.addEventListener('focusin', function () { if (cur) close(); });
    });
    $$('.mpx-p', W).forEach(function (p) {
      p.addEventListener('pointerenter', function () { clearTimeout(tm); });
      p.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') later(close, CD); });
      p.addEventListener('mouseover', function (e) { var t = e.target.closest('[data-t]'); if (t && p.contains(t)) show(t); });
      p.addEventListener('focusin', function (e) { clearTimeout(tm); var t = e.target.closest('[data-t]'); if (t && p.contains(t)) show(t); });
      p.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !cur) return;
        var f = focusables();
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); trigA(cur).focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
          var nx = cur.nextElementSibling, na = nx && (nx.matches('a') ? nx : nx.querySelector(':scope>a'));
          if (na) { e.preventDefault(); na.focus(); }
        }
      });
      /* sale layout f: arrows scroll the strip by most of its width; ends disable their arrow */
      var st = p.querySelector('.mpx-fps'), ar = $$('.mpx-fa', p);
      if (st && ar.length) {
        var ends = function () {
          var mx = st.scrollWidth - st.clientWidth - 2;
          ar.forEach(function (b) { b.disabled = mx <= 0 || (b.dataset.dir < 0 ? st.scrollLeft <= 2 : st.scrollLeft >= mx); });
        };
        ar.forEach(function (b) { b.addEventListener('click', function () { st.scrollBy({ left: b.dataset.dir * Math.max(200, st.clientWidth * 0.8), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }); });
        st.addEventListener('scroll', ends, { passive: true });
        p._ends = ends;
      }
      /* a click on a link inside: close after the page starts to move */
      p.addEventListener('click', function (e) { if (e.target.closest('a[href]')) setTimeout(close, 0); });
    });
  }

  /* document level (bound once): Esc, clicks outside, focus leaving, resize, scroll, theme editor */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cur) { var a = trigA(cur); close(); if (a) { a._mpxQuiet = 1; a.focus(); a._mpxQuiet = 0; } }
  });
  document.addEventListener('pointerdown', function (e) {
    if (!cur || !curP) return;
    if (curP.contains(e.target) || trigs.some(function (dd) { return dd.contains(e.target); })) return;
    close();
  }, true);
  document.addEventListener('focusout', function () {
    setTimeout(function () {
      if (!cur || !curP) return;
      var ae = document.activeElement;
      if (!ae || ae === document.body) return;
      if (curP.contains(ae) || trigs.some(function (dd) { return dd.contains(ae); })) return;
      close();
    }, 0);
  });
  window.addEventListener('resize', function () { if (!curP) return; if (!mq.matches) close(); else place(); });
  window.addEventListener('scroll', function () {
    if (!curP) return;
    var ae = document.activeElement;
    if (!curP.matches(':hover') && !(cur && cur.matches(':hover')) && !curP.contains(ae)) close(); else place();
  }, { passive: true });
  document.addEventListener('shopify:section:load', function () { cur = null; curP = null; document.body.classList.remove('mpx-on'); bind(); });
  document.addEventListener('shopify:block:select', function (e) {
    if (!W || !W.contains(e.target)) return;
    var p = e.target.closest('.mpx-p'), dd = p && trigs.filter(function (x) { return panelOf(x) === p; })[0];
    if (dd) open(dd);
    var t = e.target.closest('[data-t]');
    if (t) show(t);
  });
  document.addEventListener('shopify:block:deselect', function (e) { if (W && W.contains(e.target)) close(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
